import { NOTIFICATION_TOKEN } from "./actionTypes";
import { NOTIFICATION_TOKEN_URL } from "../../configs";
import Axios from "axios";

// meta: optional { app, platform } so the server routes pushes to the right app/device type.
export const saveNotificationToken = (push_token, user_id, auth_token, meta = {}) => (dispatch) => {
	// Add Authorization header for JWT authentication
	const config = {
		headers: {
			'Authorization': `Bearer ${auth_token}`
		}
	};

	console.log('[saveNotificationToken] Attempting to save FCM token', {
		user_id: user_id,
		token_preview: push_token ? push_token.substring(0, 20) + '...' : 'null',
		has_auth_token: !!auth_token
	});

	Axios.post(NOTIFICATION_TOKEN_URL, {
		push_token: push_token,
		user_id: user_id,
		token: auth_token,
		...meta,
	}, config)
		.then((response) => {
			console.log('[saveNotificationToken] Token saved successfully', {
				user_id: user_id,
				response: response.data
			});
			if (response.data) {
			}
			const token = response.data;

			return dispatch({ type: NOTIFICATION_TOKEN, payload: token });
		})
		.catch(function(error) {
			console.error('[saveNotificationToken] Failed to save token ' + JSON.stringify({ message: error.message, status: error.response ? error.response.status : null, data: error.response ? error.response.data : null, url: NOTIFICATION_TOKEN_URL }));
			console.error('[saveNotificationToken] details', {
				user_id: user_id,
				error_message: error.message,
				error_response: error.response ? {
					status: error.response.status,
					data: error.response.data
				} : null,
				token_preview: push_token ? push_token.substring(0, 20) + '...' : 'null'
			});
		});
};
